import React from 'react';
import Spinner from "./Spinner";

const Loading = () => {
    return (
        <div className="mt-5 mb-5 d-flex justify-content-center">
            <Spinner className="text-primary m-2" size="lg" />
        </div>
    );
};

export default Loading;
